import { createPrefix } from 'utils/create-prefix'

export const auth = createPrefix('/auth', {
  login: '/login',
  signup: '/signup',
  preSignupBeneficence: '/pre-signup-beneficiary',
  preSignupSponsor: '/pre-signup-partner',
  resetPassword: '/reset',
  confirmPassword: '/confirm',
})

export const admin = createPrefix('/admin', {
  events: [
    '/events',
    {
      add: '/add',
    },
  ],

  members: '/members',
  timemachine: '/timemachine',
  beneficiaries: [
    '/beneficiaries',
    {
      add: '/add',
      invoices: [
        '/invoices',
        {
          index: '',
          view: (id) => `/${id}`,
        },
      ],
      addInvoices: [
        '/add-invoices',
        {
          index: '',
          view: (id) => `/${id}`,
        },
      ],
      bankAccount: [
        '/bank-account',
        {
          index: '',
          view: (id) => `/${id}`,
        },
      ],
      update: [
        '/edit',
        {
          index: '',
          view: (id) => `/${id}`,
        },
      ],
    },
  ],
  triggers: [
    '/triggers',
    {
      add: '/add',
    },
  ],
  athletes: [
    '/athletes',
    {
      add: '/edit',
      update: [
        '/edit',
        {
          index: '',
          view: (id) => `/${id}`,
        },
      ],
    },
  ],
  tournaments: [
    '/tournaments',
    {
      add: '/add',
      update: [
        '/edit',
        {
          index: '',
          view: (id) => `/${id}`,
        },
      ],
    },
  ],
  sponsors: [
    '/sponsors',
    {
      invoices: [
        '/invoices',
        {
          index: '',
          view: (id) => `/${id}`,
        },
      ],
      addInvoices: [
        '/add-invoices',
        {
          index: '',
          view: (id) => `/${id}`,
        },
      ],
      bankAccount: [
        '/bank-account',
        {
          index: '',
          view: (id) => `/${id}`,
        },
      ],
      add: '/add',
      update: [
        '/edit',
        {
          index: '',
          view: (id) => `/${id}`,
        },
      ],
    },
  ],
  teams: [
    '/teams',
    {
      add: '/edit',
      update: [
        '/edit',
        {
          index: '',
          view: (id) => `/${id}`,
        },
      ],
      athlete: [
        '',
        {
          index: '',
          view: (id) => `/${id}`,
          addAthlete: ['/athletes', { index: '', view: (id) => `/${id}` }],
        },
      ],
    },
  ],
  charts: '/charts',
})

export const histoyOfInWins = createPrefix('/main/inwins-history', {
  index: '',
})

export const historyOfTransBene = createPrefix(
  '/main/transactions-history-beneficiary',
  {
    index: '',
  }
)

export const historyOfTransSponsor = createPrefix(
  '/main/transactions-history-sponsor',
  {
    index: '',
  }
)

export const main = createPrefix('/main', {
  index: '',
})

export const mainProfile = createPrefix('/main/profile', {
  index: '',
})

export const event = createPrefix('/main/events', {
  index: '',
  view: (id) => `/${id}`,
})

export const team = createPrefix('/main/teams', {
  index: '',
  view: (id) => `/${id}`,
})

export const athlete = createPrefix('/main/athletes', {
  index: '',
  view: (id) => `/${id}`,
})

export const profile = createPrefix('/profile', {
  index: '',
  account: '/account',
  inwins: '/inwins',
  athletes: '/athletes',
  teams: '/teams',
  tournaments: '/tournaments',
  makeInWins: [
    '/makeInWins',
    {
      add: [
        '/add',
        {
          index: '',
          view: (id) => `/${id}`,
        },
      ],
    },
  ],
  balance: '/balance',
  beneficiaries: '/beneficiaries',
  support: '/support',
  address: '/address',
  personalInfo: '/personal-info',
  donationReceipts: '/donation-receipts',
})

export const other = createPrefix('', {
  termsConditions: '/terms-conditions',
})
